import { IStarRating, Partial } from 'api/resort/types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import classNames from 'classnames';
import { Stars } from 'components/resort/Stars';
import styles from './styles.module.scss';

export const Rating = ({
  review, className,
}: {
  review: Partial<IStarRating>,
  className?: string,
}) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={classNames(styles.wrapper, className)}>
      <div className={styles.blockLeft}>
        {
          review.beginner ? (
            <div>
              {t('region.resortGuide.beginnerTitle')}
              <Stars amount={review.beginner} />
            </div>
          ) : ''
        }
        {
          review.intermediate ? (
            <div>
              {t('region.resortGuide.intermediateTitle')}
              <Stars amount={review.intermediate} />
            </div>
          ) : ''
        }
        {
          review.expert ? (
            <div>
              {t('region.resortGuide.expertTitle')}
              <Stars amount={review.expert} />
            </div>
          ) : ''
        }
        {
          review.allTerrain ? (
            <div>
              {t('region.resortGuide.allMtnTerrainTitle')}
              <Stars amount={review.allTerrain} />
            </div>
          ) : ''
        }
      </div>
      <div className={styles.blockRight}>
        {
          review.familyFriendly ? (
            <div>
              {t('region.resortGuide.familyFriendlyTitle')}
              <Stars amount={review.familyFriendly} />
            </div>
          ) : ''
        }
        {
          review.apresSki ? (
            <div>
              {t('region.resortGuide.apresSkiTitle')}
              <Stars amount={review.apresSki} />
            </div>
          ) : ''
        }
        {
          review.terrainPark ? (
            <div>
              {t('region.resortGuide.terrainParkTitle')}
              <Stars amount={review.terrainPark} />
            </div>
          ) : ''
        }
        {
          review.overallOther ? (
            <div>
              {t('resort.reviews.overallValue')}
              <Stars amount={review.overallOther} />
            </div>
          ) : ''
        }
      </div>
    </div>
  );
};
